<template>
    <section class="promo">
        <div class="promo-slider">

            <div class="promo-slider__item promo-slider__item--style-1">
                <picture>
                    <source srcset="@/assets/images/promo_1.jpg" media="(min-width: 835px)" />
                    <source srcset="@/assets/images/834promo_1.jpg" media="(min-width: 376px)" />
                    <img class="img--bg" src="@/assets/images/375promo_1.jpg" alt="img" />
                </picture>

                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="align-container">
                                <div class="align-container__item">
                                    <div class="promo-slider__wrapper-1">
                                        <h2 class="promo-slider__title">
                                            <span>We're Spreading Crypto</span>
                                            <br /><span>All Across the World</span>
                                        </h2>
                                    </div>

                                    <div class="promo-slider__wrapper-2">
                                        <p class="promo-slider__subtitle">
                                            Enabling new economies with low fee micro-transactions, large business transactions, and permissionless spending.
                                        </p>
                                    </div>

                                    <div class="promo-slider__wrapper-3">
                                        <a class="button promo-slider__button button--primary" href="javascript://">Get Started!</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="promo-slider__item promo-slider__item--style-2">
                <picture>
                    <source srcset="@/assets/images/promo_2.jpg" media="(min-width: 835px)"/>
                    <source srcset="@/assets/images/834promo_2.jpg" media="(min-width: 376px)"/>
                    <img class="img--bg" src="@/assets/images/375promo_2.jpg" alt="img"/>
                </picture>

                <div class="container">
                    <div class="row">
                        <div class="col-xl-7">
                            <div class="align-container">
                                <div class="align-container__item">
                                    <div class="promo-slider__wrapper-1">
                                        <h2 class="promo-slider__title">
                                            <span>Designing the Future</span>
                                            <br/><span>of Global Payments</span>
                                        </h2>
                                    </div>

                                    <div class="promo-slider__wrapper-2">
                                        <p class="promo-slider__subtitle">
                                            Bitcoin Cash (BCH) is a cryptocurrency built on the premise of instant payment confirmation and low transaction fees.
                                            These features, combined with the increasing desire to have greater control over one’s finances, are quickly propelling Bitcin Cash towards becoming the new global payments standard for consumers and businesses worldwide.
                                        </p>
                                    </div>

                                    <div class="promo-slider__wrapper-3">
                                        <a class="button promo-slider__button button--primary" href="javascript://">Discover</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="promo-slider__item promo-slider__item--style-3">
                <picture>
                    <source srcset="@/assets/images/promo_3.jpg" media="(min-width: 835px)"/>
                    <source srcset="@/assets/images/834promo_3.jpg" media="(min-width: 376px)"/>
                    <img class="img--bg" src="@/assets/images/375promo_3.jpg" alt="img"/>
                </picture>

                <div class="container">
                    <div class="row">
                        <div class="col-xl-8 offset-xl-2">
                            <div class="align-container">
                                <div class="align-container__item">
                                    <div class="promo-slider__wrapper-1">
                                        <h2 class="promo-slider__title">
                                            <span>Hosting &amp; Promoting</span>
                                            <br/><span>Open Source Projects</span>
                                        </h2>
                                    </div>

                                    <div class="promo-slider__wrapper-2">
                                        <p class="promo-slider__subtitle">
                                            In addition to building in-house projects, we also support the open source development of projects throughout the community.
                                        </p>
                                    </div>

                                    <div class="promo-slider__wrapper-3">
                                        <a class="button promo-slider__button button--primary" href="javascript://">Learn more</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ul class="promo-socials">
            <li class="promo-socials__item"><a class="promo-socials__link" href="javascript://"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
            <li class="promo-socials__item"><a class="promo-socials__link" href="javascript://"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
            <li class="promo-socials__item"><a class="promo-socials__link" href="javascript://"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
            <li class="promo-socials__item"><a class="promo-socials__link" href="javascript://"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
        </ul>

        <div class="promo-pannel">
            <a class="anchor promo-pannel__anchor" href="javascript://about">
                <span>Scroll Down</span></a>

            <div class="promo-pannel__video">
                <img class="img--bg" src="@/assets/images/video_block.jpg" alt="image"/>
                <a class="video-trigger" href="https://vimeo.com/398729208">
                    <span>Watch our video</span>
                    <i class="fa fa-play" aria-hidden="true"></i>
                </a>
            </div>

            <div class="promo-pannel__phones">
                <p class="promo-pannel__title">Phone numbers</p>

                <a class="promo-pannel__link" href="tel:+180012345678">+ 1800 - 123 456 78</a>

                <a class="promo-pannel__link" href="tel:+18009756511">+ 1800 - 975 65 11</a>
            </div>

            <div class="promo-pannel__email">
                <p class="promo-pannel__title">Email</p>

                <a class="promo-pannel__link" href="mailto:support@bchplease.org">
                    support@bchplease.org</a>
            </div>
        </div>

        <div class="slider__nav slider__nav--promo">
            <div class="promo-slider__count"></div>

            <div class="slider__arrows">
                <div class="slider__prev">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </div>

                <div class="slider__next">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // msg: String
    }
}
</script>

<style scoped>
/*  */
</style>
